<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-data-table :loading="carregando ? 'success' : null" no-data-text="Nenhum Usuario encontrada(o)!"
          loading-text="Carregando os itens desta tabela! Aguarde..." :headers="colunasUsuarios"
          :header-props="headerProps" :items="listaUsuarioComAdmins" :items-per-page="-1" hide-default-footer
          class="elevation-0" :key="listaUsuarioComAdmins.length">
          <template v-slot:top>
            <v-row v-if="isAdminOuProprietario">
              <v-col class="botao-novo" cols="12" sm="12" md="12">
                <v-btn class="btn-novo-permissao" @click="abrirModalUsuario()">
                  <v-icon>mdi-plus</v-icon>
                  NOVO
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.usuarioId="{ item }">
            {{ item.usuario.nomeCompleto }}
          </template>
          <template v-slot:item.actions="{ item }">
            <template v-if="isAdminOuProprietario">
              <v-btn class="mx-2" x-small fab color="success" @click="abrirModalParaEdicao(item)" title="Editar Usuario">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn class="mx-2" x-small fab color="error" @click="excluirUsuario(item)" title="Excluir Usuario">
                <v-icon small>mdi-minus</v-icon>
              </v-btn>
            </template>
            <span v-else>-</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="modalUsuario" max-width="900px" class="permissao-modal">
      <div class="permissao-modal-container">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon class="header-icon-white">mdi-account-lock-open</v-icon>
              </div>
              <div class="header-text">
                <h2 class="header-title">{{ tituloUsuarios }}</h2>
                <p class="header-subtitle">Configure as permissões de usuário para esta agenda</p>
              </div>
            </div>
          </div>
        </div>
        <div class="unified-content">
          <v-card class="unified-card" :loading="carregando ? 'success' : null" :disabled="carregando">
            <div class="form-content">
              <validation-observer ref="observerUsuario" v-slot="{ }">
                <v-row>
                  <v-col cols="10" md="10" sm="10">
                    <v-autocomplete :disabled="editar" required v-model="agendaUsuario.usuarioId"
                      :items="listaUsuarioFiltro" :loading="carregandoBuscarUsuario"
                      :search-input.sync="buscarPeloUsuario" outlined dense multiple item-text="text"
                      item-value="value" no-data-text="Sem registros"
                      label="Digite o nome do usuário ou clique para exibir a lista *" @input="onInputChange"
                      @change="onSelectionChange" class="modern-autocomplete">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="2" md="2" sm="2">
                    <v-tooltip v-if="!editar" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" class="ml-1 mt-2 info-btn-lampada">
                          <v-icon class="mx-auto"> mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Apenas usuários que ainda não possuem permissões de agenda estão disponíveis para seleção.
                        Usuários que já possuem permissões não aparecem na lista.</span>
                    </v-tooltip>
                  </v-col>
                  <v-col>
                    <div class="modern-list">
                      <div class="modern-subheader">Permissões</div>

                      <div class="permission-item" @click.stop>
                        <div class="permission-checkbox">
                          <v-checkbox class="modern-checkbox"
                            v-model="agendaUsuario.permiteCadastroAgendamentos"></v-checkbox>
                        </div>
                        <div class="permission-content">
                          <div class="permission-title">Cadastrar Agendamentos</div>
                          <div class="permission-subtitle">Criar, editar e excluir agendamentos.</div>
                        </div>
                      </div>

                      <div class="permission-item" @click.stop>
                        <div class="permission-checkbox">
                          <v-checkbox class="modern-checkbox" v-model="agendaUsuario.permiteCadastroHorarios"></v-checkbox>
                        </div>
                        <div class="permission-content">
                          <div class="permission-title">Configurar horários</div>
                          <div class="permission-subtitle">Criar, editar e excluir horários de atendimento na agenda.</div>
                        </div>
                      </div>

                      <div class="permission-item" @click.stop>
                        <div class="permission-checkbox">
                          <v-checkbox class="modern-checkbox" v-model="agendaUsuario.permiteCadastroBloqueios"></v-checkbox>
                        </div>
                        <div class="permission-content">
                          <div class="permission-title">Configurar bloqueios</div>
                          <div class="permission-subtitle">Criar, editar e excluir bloqueios de datas na agenda.</div>
                        </div>
                      </div>

                      <div class="permission-item" @click.stop>
                        <div class="permission-checkbox">
                          <v-checkbox class="modern-checkbox" v-model="agendaUsuario.permiteCadastroFeriados"></v-checkbox>
                        </div>
                        <div class="permission-content">
                          <div class="permission-title">Configurar feriados</div>
                          <div class="permission-subtitle">Criar, editar e excluir feriados de datas na agenda.</div>
                        </div>
                      </div>

                      <div class="permission-item" @click.stop>
                        <div class="permission-checkbox">
                          <v-checkbox class="modern-checkbox" v-model="agendaUsuario.permiteCadastroTipoConsulta"></v-checkbox>
                        </div>
                        <div class="permission-content">
                          <div class="permission-title">Configurar tipos de consulta</div>
                          <div class="permission-subtitle">Criar, editar e excluir tipos de consulta da agenda.</div>
                        </div>
                      </div>

                      <div class="permission-item" @click.stop>
                        <div class="permission-checkbox">
                          <v-checkbox class="modern-checkbox" v-model="agendaUsuario.permiteCadastroAvisos"></v-checkbox>
                        </div>
                        <div class="permission-content">
                          <div class="permission-title">Configurar avisos</div>
                          <div class="permission-subtitle">Criar, editar e excluir avisos da agenda.</div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </validation-observer>
            </div>
            <div class="form-actions">
              <div class="actions-container">
                <v-btn class="action-btn cancel-btn" :class="'warning'" @click="fecharModal()">
                  <v-icon left>mdi-keyboard-return</v-icon>
                  Voltar
                </v-btn>
                <v-btn class="action-btn save-btn" @click="salvar()" :loading="carregando"
                  :disabled="carregando || !agendaUsuario.usuarioId || agendaUsuario.usuarioId.length === 0">
                  <v-icon left>$saveIcon</v-icon>
                  Salvar
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { AlertaExclusaoQuestaoBooleano } from '../../helpers/MensagemHelper';
import AgendaUsuario from '../../models/agenda/AgendaUsuario';
import { UsuarioService } from '../../services/UsuarioService';
import { AgendaService } from '@/services/AgendaService';
import { decode, getToken } from '../../utils/Token';
import Role from '@/constants/enums/Role';


export default Vue.extend({
  name: 'soi-usuarioAcesso',
  props: {
    value: {
      type: Array,
      required: true,
    },
    agenda: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.listaUsuario = newValue || [];
      },
    },
    buscarPeloUsuario: {
      handler: 'buscarUsuarios',
      immediate: false,
    },
    agenda: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue && newValue.usuarioId && this.isAdminOuProprietario) {
          if (this.listaAdministradores.length === 0) {
            this.buscarAdministradores();
          }
        }
      },
    },
  },
  computed: {
    tituloUsuarios() {
      return this.editar
        ? 'Editar Permissões de Usuário desta agenda'
        : 'Criar Permissões de Usuário desta agenda';
    },
    isAdminOuProprietario(): boolean {
      const token = getToken();
      if (!token) return false;
      const decoded = decode(token);
      const idUsuarioLogado = decoded.id;
      const roleUsuario = decoded.role;

      const isAdmin = roleUsuario === Role.Admin
        || roleUsuario === Role.Administrador
        || roleUsuario === Role.AdminMedico;

      const isProprietario = this.agenda?.usuarioId === idUsuarioLogado;

      return isAdmin || isProprietario;
    },
    idUsuarioLogado(): string {
      const token = getToken();
      if (!token) return '';
      return decode(token).id;
    },
    listaUsuarioComAdmins(): any[] {
      if (!this.isAdminOuProprietario) {
        const usuariosComPermissao = Array.isArray(this.listaUsuario) ? [...this.listaUsuario] : [];
        return usuariosComPermissao.filter(
          (u: any) => String(u.usuarioId) === String(this.idUsuarioLogado),
        );
      }

      const usuariosComPermissao = Array.isArray(this.listaUsuario) ? [...this.listaUsuario] : [];
      const administradores = Array.isArray(this.listaAdministradores) ? [...this.listaAdministradores] : [];

      if (usuariosComPermissao.length === 0 && administradores.length === 0) {
        return [];
      }

      const idsExistentes = new Set(
        usuariosComPermissao.map((u: any) => String(u.usuarioId)),
      );

      const adminsNaoDuplicados = administradores.filter(
        (admin: any) => !idsExistentes.has(String(admin.usuarioId)),
      );

      return [...usuariosComPermissao, ...adminsNaoDuplicados];
    },
  },
  data() {
    return {
      carregando: false,
      carregandoBuscarUsuario: false,
      agendaUsuario: new AgendaUsuario(),
      listaUsuario: this.value,
      listaAdministradores: [] as any[],
      listaUsuarioFiltro: [] as Array<{ value: number; text: string }>,
      buscarPeloUsuario: '',
      modalUsuario: false,
      editar: false,
      agendaUsuarioEdicaoIndex: 0,
      usuarioService: new UsuarioService(),
      agendaService: new AgendaService(),
      timeoutBusca: null as any,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      colunasUsuarios: [
        {
          value: 'usuarioId',
          align: 'center',
          text: 'Usuários que podem utilizar esta agenda',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
        },
      ],
    };
  },
  mounted() {
    this.buscarUsuariosIniciais();
    if (this.isAdminOuProprietario) {
      this.buscarAdministradores();
    }
  },
  methods: {
    onInputChange(value: any): void {
      if (this.timeoutBusca) {
        clearTimeout(this.timeoutBusca);
      }
      if (!value || value === '' || value.length === 0) {
        this.buscarUsuariosIniciais();
        return;
      }
      this.timeoutBusca = setTimeout(() => {
        if (value.length >= 2) {
          this.buscarUsuarios(value);
        } else {
          this.buscarUsuariosIniciais();
        }
      }, 300);
    },
    onSelectionChange(selectedValue: any): void {
      if (selectedValue) {
        this.buscarPeloUsuario = '';
      }
    },
    async buscarUsuarios(termoPesquisado: string): Promise<void> {
      if (!termoPesquisado || termoPesquisado.trim() === '') {
        await this.buscarUsuariosIniciais();
        return;
      }

      if (termoPesquisado.length < 2) {
        await this.buscarUsuariosIniciais();
        return;
      }

      if (this.carregandoBuscarUsuario) {
        return;
      }

      this.carregandoBuscarUsuario = true;

      try {
        const response = await this.usuarioService.obterTodosOsRegistrosSemPaginacao(termoPesquisado);
        this.processarListaUsuarios(response.data);
      } catch (error) {
        console.error('Erro ao buscar usuários:', error);
        this.listaUsuarioFiltro = [];
      } finally {
        this.carregandoBuscarUsuario = false;
      }
    },
    processarListaUsuarios(usuarios: Array<{ id: number; nomeCompleto: string }>): void {
      this.listaUsuarioFiltro = [];

      usuarios.forEach((usuario) => {
        const jaExistePermissao = this.value.some((item: { usuarioId: number }) => item.usuarioId === usuario.id);

        if (!jaExistePermissao || this.editar) {
          this.listaUsuarioFiltro.push({
            value: usuario.id,
            text: usuario.nomeCompleto,
          });
        }
      });
    },
    abrirModalUsuario(): void {
      this.resetarFormulario();
      this.modalUsuario = true;
      this.buscarUsuariosIniciais();
    },
    abrirModalParaEdicao(agendaUsuario: AgendaUsuario): void {
      this.agendaUsuarioEdicaoIndex = this.listaUsuario.indexOf(agendaUsuario);
      this.buscarPeloUsuario = agendaUsuario.usuario.nomeCompleto;
      this.editar = true;
      this.modalUsuario = true;
      this.agendaUsuario = { ...agendaUsuario };
      this.buscarUsuariosIniciais();
    },
    async fecharModal(): Promise<void> {
      this.resetarFormulario();
      this.modalUsuario = false;
    },
    resetarFormulario(): void {
      this.editar = false;
      this.agendaUsuario = new AgendaUsuario();
      this.buscarPeloUsuario = '';
      this.listaUsuarioFiltro = [];
      this.agendaUsuarioEdicaoIndex = 0;
    },
    async salvar(): Promise<void> {
      if (this.carregando) {
        return;
      }

      try {
        const valid = await (
          this.$refs.observerUsuario as { validate: () => Promise<boolean> }
        ).validate();

        if (!valid) {
          return;
        }

        this.carregando = true;

        if (this.editar) {
          await this.atualizarUsuarioExistente();
        } else {
          await this.adicionarNovosUsuarios();
        }

        this.emitirAtualizacao();
        await this.fecharModal();
      } catch (error) {
        console.error('Erro ao salvar usuário:', error);
        this.$emit('error', 'Erro ao salvar permissões de usuário.');
      } finally {
        this.carregando = false;
      }
    },
    atualizarUsuarioExistente(): void {
      if (this.agendaUsuarioEdicaoIndex >= 0) {
        Object.assign(this.listaUsuario[this.agendaUsuarioEdicaoIndex], this.agendaUsuario);
      }
    },
    adicionarNovosUsuarios(): void {
      if (!Array.isArray(this.agendaUsuario.usuarioId)) {
        return;
      }

      this.agendaUsuario.usuarioId.forEach((idSelecionado: number) => {
        const usuarioSelecionado = this.listaUsuarioFiltro.find((x: { value: number }) => x.value === idSelecionado);

        if (usuarioSelecionado) {
          const novoUsuarioAgenda = {
            ...this.agendaUsuario,
            usuarioId: idSelecionado,
            usuario: {
              id: usuarioSelecionado.value,
              nomeCompleto: usuarioSelecionado.text,
            },
          };
          this.listaUsuario.push(novoUsuarioAgenda);
        }
      });
    },

    async excluirUsuario(usuario: AgendaUsuario): Promise<void> {
      if (this.carregando) {
        return;
      }

      try {
        const confirmarExclusao = await AlertaExclusaoQuestaoBooleano();

        if (!confirmarExclusao) {
          return;
        }

        this.carregando = true;

        const acessoPermissaoInput = {
          UsuarioId: usuario.usuarioId,
          AgendaId: usuario.agendaId,
          AcessoLiberado: false,
        };

        await this.agendaService.atualizaPermissaoDoUsuarioNaAgenda(
          usuario.usuarioId,
          acessoPermissaoInput,
        );

        this.removerUsuarioDaLista(usuario);
        this.emitirAtualizacao();
      } catch (error) {
        console.error('Erro ao excluir usuário:', error);
        this.$emit('error', 'Erro ao excluir usuário da agenda.');
      } finally {
        this.carregando = false;
      }
    },
    removerUsuarioDaLista(usuario: AgendaUsuario): void {
      const index = this.listaUsuario.indexOf(usuario);
      if (index > -1) {
        this.listaUsuario.splice(index, 1);
      }
    },
    emitirAtualizacao(): void {
      this.$emit('input', this.listaUsuario);
    },
    async buscarUsuariosIniciais(): Promise<void> {
      if (this.carregandoBuscarUsuario) {
        return;
      }
      this.carregandoBuscarUsuario = true;
      try {
        const response = await this.usuarioService.obterTodosOsRegistrosSemPaginacao('');
        this.processarListaUsuarios(response.data);
      } catch (error) {
        console.error('Erro ao buscar usuários iniciais:', error);
        this.listaUsuarioFiltro = [];
      } finally {
        this.carregandoBuscarUsuario = false;
      }
    },
    async buscarAdministradores(): Promise<void> {
      try {
        const response = await this.usuarioService.obterAdministradoresDaClinica();
        const administradores = response.data || [];
        this.listaAdministradores = administradores.map((admin: any) => ({
          usuarioId: admin.id || admin.Id,
          usuario: {
            id: admin.id || admin.Id,
            nomeCompleto: admin.nomeCompleto || admin.NomeCompleto,
          },
          permiteCadastroAgendamentos: true,
          permiteCadastroHorarios: true,
          permiteCadastroBloqueios: true,
          permiteCadastroFeriados: true,
          permiteCadastroTipoConsulta: true,
        }));
        this.$forceUpdate();
      } catch (error) {
        console.error('Erro ao buscar administradores:', error);
        this.listaAdministradores = [];
      }
    },
  },
});
</script>
<style scoped>
/* BOTÃO NOVO MODERNO */
.btn-novo-permissao {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
  margin-bottom: 16px !important;
}

.btn-novo-permissao:hover {
  background: var(--especialidade-secondary, #4a6bb5) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(46, 75, 157, 0.3) !important;
}

.btn-novo-permissao .v-icon {
  color: white !important;
  margin-right: 8px !important;
}

/* MODAL PERMISSÕES - ESTILO MODERNO */
.permissao-modal {
  z-index: 9999 !important;
}

.permissao-modal-container {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 900px;
  margin: 0 auto;
}

/* HEADER MODERNO */
.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
}

.header-icon-white {
  color: white !important;
  font-size: 24px !important;
}

.header-text {
  flex: 1;
}

.header-title {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 4px 0 0 0;
  font-weight: 400;
}

/* CONTEÚDO UNIFICADO */
.unified-content {
  padding: 0 24px 24px 24px;
}

.unified-card {
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.form-content {
  padding: 32px;
}

/* INPUTS MODERNOS */
.modern-autocomplete .v-input__control {
  border-radius: 12px !important;
  border: 2px solid #e0e0e0 !important;
  transition: all 0.3s ease !important;
}

.modern-autocomplete .v-input__control:hover {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.1) !important;
}

.modern-autocomplete .v-input__control:focus-within {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.2) !important;
}

/* LISTA MODERNA - NOVA ESTRUTURA */
.modern-list {
  background: #fafafa;
  border-radius: 12px;
  padding: 16px;
}

.modern-subheader {
  color: var(--especialidade-primary, #2e4b9d) !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  margin-bottom: 16px !important;
}

.permission-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  border-radius: 8px !important;
  margin-bottom: 12px !important;
  background: var(--bg-primary, white) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
  padding: 16px;
  cursor: default !important;
}

.permission-item:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-1px) !important;
}

.permission-checkbox {
  flex-shrink: 0;
  margin-top: 2px;
}

.permission-content {
  flex: 1;
  pointer-events: none !important;
}

.permission-title {
  font-weight: 600;
  font-size: 14px;
  color: var(--text-primary, #333);
  margin-bottom: 4px;
  pointer-events: none !important;
}

.permission-subtitle {
  font-size: 12px;
  color: var(--text-secondary, #666);
  line-height: 1.4;
  pointer-events: none !important;
}

.modern-checkbox {
  color: var(--especialidade-primary, #2e4b9d) !important;
}

.modern-checkbox .v-input--selection-controls__input {
  color: var(--especialidade-primary, #2e4b9d) !important;
}

/* BOTÃO INFO */
.info-btn-lampada {
  animation: info-pulse 2s infinite ease-in-out !important;
  border-radius: 50% !important;
  background-color: rgba(255, 229, 180, 0.4) !important;
  align-items: center;
}

.info-btn-lampada .v-icon {
  color: #FFB300 !important;
}

/* AÇÕES */
.form-actions {
  padding: 24px 32px 32px 32px;
  border-top: 1px solid var(--border-light, #f0f0f0);
  background: var(--bg-secondary, #fafafa);
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.action-btn {
  padding: 12px 24px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  min-width: 120px !important;
  height: 44px !important;
  transition: all 0.3s ease !important;
}

.cancel-btn:hover {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.save-btn {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  border: 2px solid var(--especialidade-primary, #2e4b9d) !important;
}

.save-btn:hover {
  background: var(--especialidade-secondary, #4a6bb5) !important;
  border-color: var(--especialidade-secondary, #4a6bb5) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(46, 75, 157, 0.3);
}

.save-btn .v-icon {
  color: white !important;
}

.cancel-btn .v-icon {
  color: #ffffff !important;
}

/* Dark mode overrides */
.theme--dark .permission-item {
  background: #424242 !important;
}

.theme--dark .permission-title {
  color: #e6e6e6;
}

.theme--dark .permission-subtitle {
  color: #b0b0b0;
}

.theme--dark .form-actions {
  background: #363636;
  border-top-color: rgba(255, 255, 255, 0.12);
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .permissao-modal-container {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .modal-header {
    padding: 20px 24px;
  }

  .header-title {
    font-size: 20px;
  }

  .form-content {
    padding: 24px;
  }

  .form-actions {
    padding: 20px 24px 24px 24px;
  }

  .actions-container {
    flex-direction: column;
  }

  .action-btn {
    width: 100% !important;
  }
}
</style>
